import React, {useMemo} from "react";
import objectPath from "object-path";
import {useHtmlClassService} from "../../../../_metronic/layout";
import {AdminDashboard} from "./AdminDashboard";

export function Dashboard() {
    const uiService = useHtmlClassService();
    const layoutProps = useMemo(() => {
        return {
            name: objectPath.get(
                uiService.config,
                "name"
            )};
    }, [uiService]);
    return <>
        {layoutProps.name === 'dof' && <AdminDashboard />}
    </>;
}
